import { useAppDispatch } from "../../../store/service";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { completeTechProfileAction } from "../../Actions/RegisterTechActions";
import { useHireflixLink } from "../Common/hooks/useHireflixLink";
import { useRegistrationContext } from "../Common/registrationContext";
import { saveRegistrationContextToLocalStorage } from "../Common/service";

export const useOnClickHireflix = ({ userId, entityId }: { userId: number; entityId: number }) => {
  const hireflixLink = useHireflixLink();
  const dispatch = useAppDispatch();
  const { registrationContext } = useRegistrationContext();

  const onClick = () => {
    saveRegistrationContextToLocalStorage(registrationContext);

    window.open(hireflixLink, "_blank");

    EventTracker.send({
      eventName: Event.Name.TECH_CLICK_HIREFLIX,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.TECH,
      entityId: entityId,
    });

    dispatch(completeTechProfileAction({ techRegistrationPageNo: 5, userId }));
  };

  return { onClick };
};
